import { i18n } from 'i18n';

import { TRANSFORM_LOCALE } from './transformLocale';

export const formatDate = (
	date: Date | null,
	format:
		| 'short'
		| 'medium'
		| 'long'
		| 'json'
		| 'iso'
		| 'dayMonth'
		| 'humanoid'
		| 'shortTime'
		| 'dayFullMonth'
		| 'weekday' = 'short',
	filter: 'from' | 'to' = 'from',
) => {
	if (!date) {
		return null;
	}

	switch (format) {
		case 'shortTime':
			return date.toLocaleString(TRANSFORM_LOCALE[i18n.language], {
				hour: '2-digit',
				minute: '2-digit',
			});

		case 'weekday':
			return date.toLocaleString(TRANSFORM_LOCALE[i18n.language], {
				weekday: 'short',
			});

		case 'short':
			return date.toLocaleString(TRANSFORM_LOCALE[i18n.language], {
				month: '2-digit',
				day: '2-digit',
				year: 'numeric',
			});

		case 'dayMonth':
			return date.toLocaleString(TRANSFORM_LOCALE[i18n.language], {
				month: 'short',
				day: '2-digit',
			});

		case 'dayFullMonth':
			return date.toLocaleString(TRANSFORM_LOCALE[i18n.language], {
				month: 'long',
				day: '2-digit',
			});

		case 'medium':
			return date.toLocaleString(TRANSFORM_LOCALE[i18n.language], {
				month: '2-digit',
				day: '2-digit',
				year: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
			});

		case 'long':
			return date.toLocaleString(TRANSFORM_LOCALE[i18n.language], {
				month: 'short',
				day: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit',
			});

		case 'json':
			if (filter === 'to') {
				date.setDate(date.getDate() + 1);
				date.setMilliseconds(date.getMilliseconds() - 1);
			}

			return date.toJSON();

		case 'iso':
			return date.toLocaleDateString('sv-SE');

		case 'humanoid':
			return date.toLocaleString(TRANSFORM_LOCALE[i18n.language], {
				month: 'short',
				day: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
			});

		default:
			return null;
	}
};
